import React from "react";

export default function nosePointed(): React.ReactElement {
  return (
    <svg
      style={{
        width: "12%",
        height: "12%",
        position: "absolute",
        top: "14%",
        left: "44%",
      }}
      width="36"
      height="48"
      viewBox="0 0 36 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 5L18 30L8 40"
        stroke="#171921"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
